<template>
  <div>
    <div class="row">
      <div class="col-12">
        <page-header
          :page="page"
          @onReturn="() => $router.back()"
          :has-return="true"
       />
      </div>
    </div>
    <div class="row">
      <div class="col">
        <filter-manager
          :display-advanced="false"
          class="search-bar"
          items-container-class="flex-wrap"
          search-icon="fa fa-sync"
          search-text="Procesar"
          search-container-class="btn-process"
          v-model="model.search.filters"
          :filters="filterManagerConfig"
          @search="onHandlerSearch"
          ref="filterRef"
        />
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from 'PageHeader'
import FilterManager from "FilterManager";
import TicketsAPI from '@/services/api/detickets.api'
import ReportServices from '@/modules/report/api'
import DocumentServices from '@//modules/report/document'

export default {
  components: {
    PageHeader,
    FilterManager,
  },
  data: () => 
  ({
    page: {
      icon: 'fas fa-clipboard-list-check',
      title: 'Solicitudes Asistencia MiPE',
      routes: ["Informes", "Solicitudes Asistencia MiPE"]
    },
    model: {
      search: {
        filters: {
          dateFrom: null,
          dateTo: null,
          application: null,
          caseType: null,
          status: null,
          assigned: null,
          receiptMediums: null
        },
        collections: {
          applications:[],
          caseTypes: [],
          assigned:[],
          statuses: [],
          receiptMediums: []
        }
      },
    },
  }),
  computed: {
    filterManagerConfig() {
    return [
      {
        name: 'dateFrom',
        component: 'custom-date-picker',
        label: 'Rango de Fecha',
        placeholder: 'Fecha Desde',
        error: "Favor seleccionar la fecha de comienzo.",
        validations: "required",
        class: 'col-md-2',
        maxDate: new Date(),
        value: this.model.search.filters.dateFrom,
      },
      {
        name: 'dateTo',
        component: 'custom-date-picker',
        label: ' ',
        placeholder: 'Fecha Hasta',
        error: "Favor seleccionar la fecha de finalización.",
        validations: "required",
        class: 'col-md-2 pt-2',
        maxDate: new Date(),
        value: this.model.search.filters.dateTo,
      },
      {
        name: 'application',
        component: 'custom-drop-down',
        fieldKey: 'id',
        fieldName: 'name',
        label: 'Aplicación',
        placeholder: 'Seleccionar',
        class: 'col-md-4',
        options: this.model.search.collections.applications,
        value: this.model.search.filters.application,
      },
       {
        name: 'caseType',
        component: 'custom-drop-down',
        fieldKey: 'id',
        fieldName: 'name',
        label: 'Tipo de Caso',
        placeholder: 'Seleccionar',
        class: 'col-md-4',
        options: this.model.search.collections.caseTypes,
        value: this.model.search.filters.caseType,
      },
      {
        name: 'status',
        component: 'custom-drop-down',
        fieldKey: 'id',
        fieldName: 'name',
        label: 'Estatus',
        placeholder: 'Seleccionar',
        class: 'col-md-4',
        options: this.model.search.collections.statuses,
        value: this.model.search.filters.status,
      },
      {
        name: 'assigned',
        component: 'custom-drop-down',
        fieldKey: 'id',
        fieldName: 'name',
        label: 'Asignado',
        placeholder: 'Seleccionar',
        class: 'col-md-4',
        options: this.model.search.collections.assigned,
        value: this.model.search.filters.assigned,
      },
      {
        name: 'receiptMedium',
        component: 'custom-drop-down',
        fieldKey: 'id',
        fieldName: 'name',
        label: 'Medio de Recibo',
        placeholder: 'Seleccionar',
        class: 'col-md-4',
        options: this.model.search.collections.receiptMediums,
        value: this.model.search.filters.receiptMedium,
      },
    ]},
  },
  async mounted() {
    this.initFilters()
  },
  methods: {
    async initFilters() {
       TicketsAPI.getApplications()
        .then((res) => {
          this.model.search.collections.applications = res.data; 
        })
        .catch();
        TicketsAPI.getAssigned()
        .then((res) => {
          this.model.search.collections.assigned = res.data; 
          this.model.search.filters.assigned = this.model.search.collections.assigned.filter((s) => s.selected)[0];
        })
        .catch();
        TicketsAPI.getStatuses()
        .then((res) => {
          this.model.search.collections.statuses = res.data; 
          })
        .catch();
        TicketsAPI.getCaseTypes()
        .then((res) => {  
          this.model.search.collections.caseTypes = res.data; 
          })
        .catch();
        TicketsAPI.getReceiptMedias()
        .then((res) => {
          this.model.search.collections.receiptMediums = res.data; 
          })
        .catch();
    },
    async onHandlerSearch() {
      
      const isValid = await this.$refs.filterRef.$refs.formValidator.validate();
      if (isValid) {
        this.process(this.model.search.filters.dateFrom, this.model.search.filters.dateTo);
      }
    },
    async process(dateFrom, dateTo) {
      if(dateFrom > dateTo)  {
        this.ShowToast('Atención', 'La Fecha Hasta no puede ser menor a la Fecha Desde.', 'error')
        return;
      }
       const formatYmd = date => date.toISOString().slice(0, 10);
       await ReportServices.getReport('assistanceMiPE', {
        FromDate: formatYmd(dateFrom),
        ToDate: formatYmd(dateTo),
        ApplicationId: this.model.search.filters.application?.id,
        ItemReceiptMediumId: this.model.search.filters.receiptMedium?.id,
        ItemStatusId: this.model.search.filters.status?.id,
        UserId: this.model.search.filters.assigned?.id,
      })
      .then(res => DocumentServices.Download(res.data));
    },
  },
}
</script>